import { Chip } from '@customink/pigment-react';
import { useTheme, Theme, SxProps } from '@mui/material';
import { OrderSummary } from '~/adapters/services/accounts/orders/types';
import { orderStatusToFriendlyString, FriendlyOrderStatus } from '~/pages/OrderHistory/lib/getAccountsPortalOrderState';

const statusToChipBackground = (status: FriendlyOrderStatus, theme: Theme) => {
    switch (status) {
        case FriendlyOrderStatus.InProgress:
            return `linear-gradient(0deg, rgba(25, 128, 56, 0.1), rgba(25, 128, 56, 0.1)), ${theme.palette.background.default}`;
        default:
            return `linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%), ${theme.palette.background.default}`;
    }
};

const statusToChipTextColor = (status: FriendlyOrderStatus, theme: Theme) => {
    switch (status) {
        case FriendlyOrderStatus.InProgress:
            return theme.palette.success.main;
        default:
            return theme.palette.text.primary;
    }
};

export function OrderChip({ order, sx }: { order: OrderSummary; sx?: SxProps }) {
    const status = orderStatusToFriendlyString(order);
    const theme = useTheme();
    return (
        <Chip
            sx={{
                background: statusToChipBackground(status, theme),
                color: statusToChipTextColor(status, theme),
                fontWeight: theme.typography.fontWeightBold,
                ...sx,
            }}
            label={status}
            variant="filled"
        />
    );
}
